import { http } from '@/core/helpers/axiosHelper';
import { ApiResource } from '@/core/models/ApiResource.interface';
import { LocationQuery } from 'vue-router';
import { UnifiedPostRequest } from './unified-post-request.interface';

export class UnifiedPostRequestService {
   async getUnifiedPostRequests(query?: LocationQuery) {
      const response = await http.get<ApiResource<Array<UnifiedPostRequest>>>(`/unified-post-requests`, { params: { ...query } });
      return response.data;
   }

   async getUnifiedPostRequest() {
      throw Error('Method not implemented');
   }

   async postUnifiedPostRequest() {
      throw Error('Method not implemented');
   }

   async putUnifiedPostRequest() {
      throw Error('Method not implemented');
   }

   async deleteUnifiedPostRequest() {
      throw Error('Method not implemented');
   }
}
